export enum TeamUserRoles {
  BUSINESS_HEAD = 'business_head',
  MANAGER = 'manager',
  TEAM_LEADER = 'team_leader',
  RECRUITER = 'recruiter',
  SUPPORT = 'support',
  MANAGEMENT = 'management',
}

export enum JobAssignStatus {
  NEW = 'new',
  TL_ASSIGNED = 'tlAssigned',
  RECRUITER_ASSIGNED = 'recruiterAssigned',
  RECRUITER_ACCEPTED = 'recruiterAccepted',
  TL_UNALLOCATED = 'tlUnallocated',
  RECRUITER_UNALLOCATED = 'recruiterUnallocated',
  READY_FOR_REVIEW = 'readyForReview',
  TL_APPROVED = 'tlApproved',
  SUBMITTED = 'submitted',
}

export enum JobQueueTableType {
  // Recruiter
  RECRUITER_NEW = 'recruiter_new',
  RECRUITER_PENDING = 'recruiter_pending',
  RECRUITER_SUBMITTED = 'recruiter_submitted',

  // Team Lead
  TEAM_LEAD_NEW = 'team_lead_new',
  TEAM_LEAD_ASSIGNED = 'team_lead_assigned',
  TEAM_LEAD_READY_FOR_REVIEW = 'team_lead_ready_for_review',
  TEAM_LEAD_APPROVED = 'team_lead_approved',

  // Support - Support Queue
  SUPPORT_PENDING = 'support_pending',
  SUPPORT_SUBMITTED = 'support_submitted',

  // Support - Team Lead Queue (read-only)
  SUPPORT_TL_NEW = 'support_tl_new',
  SUPPORT_TL_ASSIGNED = 'support_tl_assigned',
  SUPPORT_TL_READY_FOR_REVIEW = 'support_tl_ready_for_review',
  SUPPORT_TL_APPROVED = 'support_tl_approved',

  // Manager
  MANAGER_UNALLOCATED = 'manager_unallocated',
  MANAGER_ASSIGNED = 'manager_assigned',
  MANAGER_READY_FOR_REVIEW = 'manager_ready_for_review',
  MANAGER_APPROVED = 'manager_approved',
  MANAGER_SUBMITTED = 'manager_submitted',

  // Business Head
  BUSINESS_HEAD_UNALLOCATED = 'business_head_unallocated',
  BUSINESS_HEAD_ASSIGNED = 'business_head_assigned',
  BUSINESS_HEAD_READY_FOR_REVIEW = 'business_head_ready_for_review',
  BUSINESS_HEAD_APPROVED = 'business_head_approved',
  BUSINESS_HEAD_SUBMITTED = 'business_head_submitted',

  // Management - Job Queue
  MANAGEMENT_JQ_UNALLOCATED = 'management_jq_unallocated',
  MANAGEMENT_JQ_RECRUITER = 'management_jq_recruiter',
  MANAGEMENT_JQ_TEAM_LEAD = 'management_jq_team_lead',
  MANAGEMENT_JQ_SUPPORT = 'management_jq_support',
  MANAGEMENT_JQ_SUBMITTED = 'management_jq_submitted',

  // Management - Bench Queue
  MANAGEMENT_BQ_ALL_JOBS = 'management_bq_all_jobs',
  MANAGEMENT_BQ_MY_JOBS = 'management_bq_my_jobs',
  MANAGEMENT_BQ_OVERDUE = 'management_bq_overdue',
  MANAGEMENT_BQ_CLOSED = 'management_bq_closed',

  // Business Head - Bench Queue
  BH_BQ_ALL_JOBS = 'bh_bq_all_jobs',
  BH_BQ_MY_JOBS = 'bh_bq_my_jobs',
  BH_BQ_OVERDUE = 'bh_bq_overdue',
  BH_BQ_CLOSED = 'bh_bq_closed',
}

export enum TeamsSortBy {
  NEWEST_FIRST = 'newest_first',
  OLDEST_FIRST = 'oldest_first',
  UNKNOWN_VENDOR = 'unknown_vendor',
  KNOWN_VENDOR = 'known_vendor',
  ASSIGNED_FIRST = 'assigned_first',
}

export const sortOptions = [
  { label: 'Newest First', value: TeamsSortBy.NEWEST_FIRST },
  { label: 'Oldest First', value: TeamsSortBy.OLDEST_FIRST },
  { label: 'Assigned First', value: TeamsSortBy.ASSIGNED_FIRST },
  { type: 'divider' },
  { label: 'Known Vendor', value: TeamsSortBy.KNOWN_VENDOR },
  { label: 'Unknown Vendor', value: TeamsSortBy.UNKNOWN_VENDOR },
];

export const defaultPercentage = '60';
